module.exports = __webpack_public_path__ + "static/media/20.021b619f.jpg";